import { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  el: {
    app_title: "Ergo",
    app_subtitle: "Εμπόριο · Υπηρεσίες · Παραγωγή",
    nav_dashboard: "Επισκόπηση",
    nav_documents: "Παραστατικά",
    nav_contacts: "Πελάτες & Προμηθευτές",
    nav_settings: "Ρυθμίσεις Εταιρείας",
    nav_users: "Χρήστες",
    nav_brand: "Λογότυπο",
    brand_hint: "Επιλέξτε την εμφάνιση του λογοτύπου. Κάθε παραλλαγή φαίνεται σε φωτεινό, σκούρο φόντο και σε μικρά μεγέθη. Η επιλογή εφαρμόζεται άμεσα στην πλαϊνή μπάρα και στη σελίδα σύνδεσης.",
    brand_active: "Ενεργό",
    brand_pick: "Επιλογή",
    brand_saved: "Το λογότυπο άλλαξε",
    nav_sales: "Πωλήσεις",
    nav_purchases: "Αγορές – Έξοδα",
    account_suggested: "Προτάθηκε ο λογαριασμός της τελευταίας συναλλαγής:",
    history: "Ιστορικό ενεργειών",
    created_by: "Δημιουργία",
    updated_by: "Τελ. αλλαγή",
    no_history: "Δεν υπάρχει καταγεγραμμένο ιστορικό",
    hist_created: "Δημιουργία",
    hist_updated: "Επεξεργασία",
    hist_status: "Αλλαγή κατάστασης",
    login_hero: "Η λογιστική της επιχείρησής σας, σε ένα σύστημα.",
    login_hero_sub: "Παραστατικά, πελάτες, μισθοδοσία, myDATA και Γενική Λογιστική — με έλεγχο πρόσβασης ανά χρήστη.",
    login_title: "Σύνδεση",
    login_sub: "Εισάγετε τα στοιχεία του λογαριασμού σας",
    login_button: "Σύνδεση",
    username: "Όνομα χρήστη",
    password: "Κωδικός",
    logout: "Αποσύνδεση",
    you: "εσείς",
    full_name: "Ονοματεπώνυμο",
    role: "Ρόλος",
    role_superadmin: "Υπερδιαχειριστής",
    role_admin: "Διαχειριστής",
    role_user: "Χρήστης",
    modules: "Πρόσβαση",
    modules_access: "Καρτέλες που βλέπει ο χρήστης",
    admin_all_modules: "Οι διαχειριστές έχουν πρόσβαση σε όλες τις καρτέλες και στη διαχείριση χρηστών.",
    active: "Ενεργός",
    inactive: "Ανενεργός",
    created: "Δημιουργία",
    new_user: "Νέος χρήστης",
    edit_user: "Επεξεργασία χρήστη",
    users_hint: "Δημιουργήστε χρήστες και ορίστε ποιες καρτέλες βλέπει ο καθένας. Μόνο ο Υπερδιαχειριστής μπορεί να διαγράψει χρήστες.",
    user_saved: "Ο χρήστης αποθηκεύτηκε",
    user_deleted: "Ο χρήστης διαγράφηκε",
    confirm_delete_user: "Ο χρήστης θα διαγραφεί οριστικά. Συνέχεια;",
    new_password_optional: "Νέος κωδικός (προαιρετικό)",
    change_password: "Αλλαγή κωδικού",
    current_password: "Τρέχων κωδικός",
    new_password: "Νέος κωδικός (τουλ. 6 χαρακτήρες)",
    password_changed: "Ο κωδικός άλλαξε",
    err_invalid_credentials: "Λάθος όνομα χρήστη ή κωδικός",
    err_too_many_attempts: "Πολλές αποτυχημένες προσπάθειες — δοκιμάστε ξανά σε 15 λεπτά",
    err_user_inactive: "Ο λογαριασμός είναι ανενεργός",
    err_not_authenticated: "Απαιτείται σύνδεση",
    err_token_expired: "Η σύνδεση έληξε — συνδεθείτε ξανά",
    err_forbidden: "Δεν έχετε δικαίωμα πρόσβασης",
    err_username_exists: "Το όνομα χρήστη υπάρχει ήδη",
    err_invalid_user_data: "Όνομα χρήστη ≥3 και κωδικός ≥6 χαρακτήρες",
    err_password_too_short: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
    err_wrong_password: "Λάθος τρέχων κωδικός",
    err_cannot_delete_superadmin: "Ο Υπερδιαχειριστής δεν διαγράφεται",
    err_cannot_edit_superadmin: "Δεν μπορείτε να επεξεργαστείτε τον Υπερδιαχειριστή",
    err_only_superadmin_deletes: "Μόνο ο Υπερδιαχειριστής διαγράφει χρήστες",
    err_cannot_delete_self: "Δεν μπορείτε να διαγράψετε τον εαυτό σας",
    err_cannot_deactivate_self: "Δεν μπορείτε να απενεργοποιήσετε τον εαυτό σας",
    kpi_total_revenue: "Εισπραχθέντα Έσοδα",
    kpi_unpaid_invoices: "Ανεξόφλητα Τιμολόγια",
    kpi_active_contacts: "Ενεργές Επαφές",
    kpi_documents: "Παραστατικά",
    kpi_overdue: "εκπρόθεσμα",
    kpi_customers: "Πελάτες",
    kpi_suppliers: "Προμηθευτές",
    kpi_purchases: "Αγορές",
    chart_title: "Πωλήσεις & Αγορές (6 μήνες)",
    chart_sales: "Πωλήσεις",
    chart_purchases: "Αγορές",
    recent_docs: "Πρόσφατα Παραστατικά",
    vat_summary: "Σύνοψη Φ.Π.Α.",
    vat_out: "Φ.Π.Α. Εκροών",
    vat_in: "Φ.Π.Α. Εισροών",
    vat_due: "Φ.Π.Α. προς απόδοση",
    view_all: "Όλα",
    doc_invoice: "Τιμολόγιο Πώλησης",
    doc_service_invoice: "Τιμολόγιο Παροχής Υπηρεσιών",
    doc_retail_receipt: "Απόδειξη Λιανικής Πώλησης",
    doc_purchase: "Τιμολόγιο Αγοράς",
    doc_purchase_service: "Τιμολόγιο Παροχής Υπηρεσιών (Αγορά)",
    doc_expense: "Απόδειξη Λιανικής (Έξοδο)",
    group_all: "Όλα",
    group_sales: "Πωλήσεις",
    group_purchases: "Αγορές – Έξοδα",
    group_total: "Σύνολο επιλογής",
    new_sale: "Νέα Πώληση",
    new_purchase: "Νέα Αγορά / Έξοδο",
    search_account: "Αναζήτηση λογαριασμού (κωδικός ή όνομα)…",
    no_results: "Δεν βρέθηκαν αποτελέσματα",
    account_required_hint: "Στα παραστατικά εξόδων κάθε γραμμή απαιτεί τριτοβάθμιο λογαριασμό εξόδου για έκδοση.",
    account_required_hint_sales: "Στα παραστατικά πωλήσεων κάθε γραμμή απαιτεί τριτοβάθμιο λογαριασμό εσόδου (ομάδα 7) για έκδοση.",
    err_account_required: "Επιλέξτε λογαριασμό εξόδου σε κάθε γραμμή πριν την έκδοση",
    err_unknown_account: "Άγνωστος λογαριασμός λογιστικού σχεδίου",
    status_draft: "Πρόχειρο",
    status_issued: "Εκδόθηκε",
    status_paid: "Εξοφλήθηκε",
    status_cancelled: "Ακυρώθηκε",
    status_overdue: "Εκπρόθεσμο",
    new_document: "Νέο Παραστατικό",
    edit_document: "Επεξεργασία Παραστατικού",
    new_contact: "Νέα Επαφή",
    edit_contact: "Επεξεργασία Επαφής",
    name: "Επωνυμία / Όνομα",
    type: "Τύπος",
    customer: "Πελάτης",
    supplier: "Προμηθευτής",
    both: "Πελάτης & Προμηθευτής",
    vat_id: "Α.Φ.Μ.",
    tax_office: "Δ.Ο.Υ.",
    address: "Διεύθυνση",
    city: "Πόλη",
    phone: "Τηλέφωνο",
    email: "Email",
    payment_terms: "Όροι πληρωμής (ημέρες)",
    notes: "Σημειώσεις",
    save: "Αποθήκευση",
    cancel: "Άκυρο",
    delete: "Διαγραφή",
    edit: "Επεξεργασία",
    view: "Προβολή",
    search: "Αναζήτηση...",
    all_types: "Όλοι οι τύποι",
    all_statuses: "Όλες οι καταστάσεις",
    no_results: "Δεν βρέθηκαν αποτελέσματα",
    confirm_delete_title: "Επιβεβαίωση διαγραφής",
    confirm_delete_contact: "Η επαφή θα διαγραφεί οριστικά. Συνέχεια;",
    confirm_delete_doc: "Το παραστατικό θα διαγραφεί οριστικά. Συνέχεια;",
    contact_saved: "Η επαφή αποθηκεύτηκε",
    contact_deleted: "Η επαφή διαγράφηκε",
    contact_has_docs: "Η επαφή έχει παραστατικά και δεν μπορεί να διαγραφεί",
    doc_saved: "Το παραστατικό αποθηκεύτηκε",
    doc_deleted: "Το παραστατικό διαγράφηκε",
    status_updated: "Η κατάσταση ενημερώθηκε",
    settings_saved: "Οι ρυθμίσεις αποθηκεύτηκαν",
    error: "Κάτι πήγε στραβά",
    number: "Αριθμός",
    date: "Ημερομηνία",
    issue_date: "Ημ/νία Έκδοσης",
    due_date: "Ημ/νία Λήξης",
    payment_method: "Τρόπος Πληρωμής",
    pay_bank: "Τραπεζική κατάθεση",
    pay_cash: "Μετρητά",
    pay_card: "Κάρτα",
    pay_credit: "Επί πιστώσει",
    contact: "Επαφή",
    select_contact: "Επιλέξτε επαφή",
    status: "Κατάσταση",
    total: "Σύνολο",
    line_items: "Γραμμές",
    description: "Περιγραφή",
    quantity: "Ποσ.",
    unit_price: "Τιμή Μον.",
    vat_rate: "Φ.Π.Α. %",
    vat_deductible: "ΦΠΑ εκπίπτει",
    vat_deductible_hint: "Ξετσεκάρετε «ΦΠΑ εκπίπτει» για δαπάνες με μη εκπιπτόμενο ΦΠΑ (π.χ. φιλοξενία, ΙΧ επιβατικά, καύσιμα ΙΧ). Ο ΦΠΑ τότε επιβαρύνει τον λογαριασμό εξόδου αντί του 54.00.",
    non_deductible_short: "μη εκπ.",
    supplier_number: "Αρ. παραστατικού προμηθευτή",
    supplier_number_ph: "π.χ. ΤΙΜ Α-1234",
    err_supplier_number_exists: "Υπάρχει ήδη παραστατικό αυτού του προμηθευτή με τον ίδιο αριθμό",
    line_total: "Αξία",
    add_line: "Προσθήκη γραμμής",
    subtotal: "Καθαρή Αξία",
    vat_amount: "Φ.Π.Α.",
    total_amount: "Συνολικό Ποσό",
    print_pdf: "Εκτύπωση / PDF",
    back: "Πίσω",
    change_status: "Αλλαγή κατάστασης",
    mark_issued: "Έκδοση",
    mark_paid: "Εξόφληση",
    mark_cancelled: "Ακύρωση",
    issuer: "Εκδότης",
    recipient: "Λήπτης",
    signature: "Υπογραφή & Σφραγίδα",
    company_settings: "Στοιχεία Εταιρείας",
    company_settings_hint: "Εμφανίζονται στην εκτύπωση παραστατικών.",
    company_name: "Επωνυμία",
    activity: "Δραστηριότητα",
    iban: "IBAN",
    required: "Υποχρεωτικό πεδίο",
    afm_invalid: "Το Α.Φ.Μ. πρέπει να έχει 9 ψηφία",
    items_required: "Προσθέστε τουλάχιστον μία γραμμή με περιγραφή",
    documents_of: "Παραστατικά επαφής",
    theme: "Θέμα",
    welcome: "Καλώς ήρθατε",
    dashboard_hint: "Συνοπτική εικόνα της επιχείρησης σήμερα.",
    dashboard_greeting: "Οικονομική εικόνα",
    types: "Τύποι",
    nav_payroll: "Μισθοδοσία",
    payments: "Εισπράξεις & Πληρωμές",
    add_payment: "Καταγραφή πληρωμής",
    amount: "Ποσό",
    reference: "Αρ. απόδειξης είσπραξης/πληρωμής",
    paid_amount: "Πληρωμένο",
    balance: "Υπόλοιπο",
    payment_saved: "Η πληρωμή καταγράφηκε",
    payment_deleted: "Η πληρωμή διαγράφηκε",
    amount_exceeds: "Το ποσό υπερβαίνει το υπόλοιπο",
    confirm_delete_payment: "Η πληρωμή θα διαγραφεί οριστικά. Συνέχεια;",
    no_payments: "Δεν υπάρχουν πληρωμές",
    pay_full: "Ολόκληρο υπόλοιπο",
    contact_card: "Καρτέλα Επαφής",
    receivable: "Απαιτήσεις (πωλήσεις)",
    payable: "Υποχρεώσεις (αγορές)",
    invoiced: "Τιμολογημένα",
    collected: "Εισπραχθέντα",
    paid_out: "Πληρωθέντα",
    open_balance: "Ανοιχτό υπόλοιπο",
    overdue_balance: "Ληξιπρόθεσμα",
    transactions: "Ιστορικό συναλλαγών",
    payments_history: "Ιστορικό πληρωμών",
    employees: "Εργαζόμενοι",
    payslips: "Μισθοδοσίες",
    new_employee: "Νέος Εργαζόμενος",
    edit_employee: "Επεξεργασία Εργαζομένου",
    employee: "Εργαζόμενος",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    amka: "Α.Μ.Κ.Α.",
    ama: "Α.Μ. ΕΦΚΑ",
    position: "Ειδικότητα",
    hire_date: "Ημ/νία Πρόσληψης",
    birth_date: "Ημ/νία Γέννησης",
    children: "Τέκνα",
    employment_type: "Απασχόληση",
    full_time: "Πλήρης",
    part_time: "Μερική",
    weekly_hours: "Ώρες / εβδομάδα",
    gross_salary: "Μικτός μηνιαίος μισθός",
    hourly_rate: "Ωρομίσθιο",
    active: "Ενεργός",
    inactive: "Ανενεργός",
    employee_saved: "Ο εργαζόμενος αποθηκεύτηκε",
    employee_deleted: "Ο εργαζόμενος διαγράφηκε",
    employee_has_payslips: "Ο εργαζόμενος έχει μισθοδοσίες και δεν μπορεί να διαγραφεί",
    confirm_delete_employee: "Ο εργαζόμενος θα διαγραφεί οριστικά. Συνέχεια;",
    kind: "Είδος",
    kind_salary: "Μηνιαίος μισθός",
    kind_christmas: "Δώρο Χριστουγέννων",
    kind_easter: "Δώρο Πάσχα",
    kind_leave: "Επίδομα Αδείας",
    period: "Περίοδος",
    year: "Έτος",
    month: "Μήνας",
    run_payroll: "Εκτέλεση μισθοδοσίας",
    run_payroll_hint: "Δημιουργεί μισθοδοσίες για όλους τους ενεργούς εργαζόμενους της περιόδου.",
    payslips_created: "μισθοδοσίες δημιουργήθηκαν",
    payslips_skipped: "υπήρχαν ήδη",
    gross: "Μικτά",
    efka_employee: "Εισφορές εργαζομένου (ΕΦΚΑ)",
    efka_employer: "Εισφορές εργοδότη (ΕΦΚΑ)",
    taxable: "Φορολογητέο",
    fmy: "Φ.Μ.Υ. (παρακράτηση)",
    net: "Καθαρά πληρωτέα",
    employer_cost: "Κόστος εργοδότη",
    payslip: "Απόδειξη Πληρωμής Αποδοχών",
    payslip_deleted: "Η μισθοδοσία διαγράφηκε",
    confirm_delete_payslip: "Η μισθοδοσία θα διαγραφεί οριστικά. Συνέχεια;",
    payroll_settings: "Ποσοστά εισφορών",
    rate_employee: "Εργαζόμενος %",
    rate_employer: "Εργοδότης %",
    days_basis: "Ημέρες βάσης",
    kpi_payroll: "Μισθοδοσία μήνα",
    total_net: "Σύνολο καθαρών",
    total_cost: "Συνολικό κόστος",
    tax_note: "Υπολογισμός βάσει κλίμακας 2026 (ν. 5246/2025), 14 μισθοί/έτος, μείωση φόρου ανά τέκνα. Τα δώρα προσαυξάνονται κατά 4,166%.",
    all_kinds: "Όλα τα είδη",
    payroll_paid_on: "Πληρώθηκε",
    afm_short: "ΑΦΜ",
    absences: "Άδειες & Απουσίες",
    new_absence: "Νέα καταχώρηση",
    edit_absence: "Επεξεργασία καταχώρησης",
    abs_annual_leave: "Κανονική άδεια",
    abs_sick: "Ασθένεια",
    abs_unpaid: "Άδεια άνευ αποδοχών",
    abs_overwork: "Υπερεργασία (+20%)",
    abs_overtime: "Υπερωρία (+40%)",
    start_date: "Από",
    end_date: "Έως",
    hours: "Ώρες",
    days: "Ημέρες",
    absence_saved: "Η καταχώρηση αποθηκεύτηκε",
    absence_deleted: "Η καταχώρηση διαγράφηκε",
    confirm_delete_absence: "Η καταχώρηση θα διαγραφεί οριστικά. Συνέχεια;",
    leave_balance: "Υπόλοιπα αδειών έτους",
    entitlement: "Δικαίωμα",
    used: "Χρήση",
    remaining: "Υπόλοιπο",
    sick_days: "Ημ. ασθένειας",
    unpaid_days: "Ημ. άνευ αποδοχών",
    overtime_hours: "Ώρες υπερ.",
    base_gross: "Βασικός μισθός",
    overtime_pay: "Αμοιβή υπερεργασίας/υπερωριών",
    sick_deduction: "Κράτηση ασθένειας",
    unpaid_deduction: "Κράτηση άδειας άνευ αποδοχών",
    adjustments: "Προσαυξήσεις / Κρατήσεις",
    recalculate: "Επανυπολογισμός",
    recalculated: "Η μισθοδοσία επανυπολογίστηκε",
    all_employees: "Όλοι οι εργαζόμενοι",
    select_employee: "Επιλέξτε εργαζόμενο",
    sick_rule: "Ασθένεια: πρώτες ημέρες / έτος",
    sick_first_pct: "Κράτηση πρώτων ημερών %",
    sick_after_pct: "Κράτηση επόμενων ημερών %",
    absence_note: "Οι απουσίες του μήνα υπολογίζονται αυτόματα στη μηνιαία μισθοδοσία. Ασθένεια: οι πρώτες 3 ημέρες/έτος με κράτηση 50%, οι επόμενες 100% (επιδότηση ΕΦΚΑ). Ωρομίσθιο = μισθός × 6 / (25 × ώρες/εβδ.).",
    no_working_days: "Το διάστημα δεν περιέχει εργάσιμες ημέρες",
    all_year: "Όλο το έτος",
    nav_mydata: "myDATA (ΑΑΔΕ)",
    mydata_title: "Διασύνδεση ΑΑΔΕ myDATA",
    mydata_settings_hint: "Τα διαπιστευτήρια εκδίδονται από το myAADE → Εγγραφή στο myDATA REST API. Αποθηκεύονται μόνο στον server.",
    mydata_mode: "Περιβάλλον",
    mode_mock: "Προσομοίωση (MOCK)",
    mode_dev: "Δοκιμαστικό ΑΑΔΕ",
    mode_production: "Παραγωγικό ΑΑΔΕ",
    mydata_user_id: "aade-user-id",
    mydata_key: "Ocp-Apim-Subscription-Key",
    mydata_key_hint: "Αφήστε κενό για να διατηρηθεί το υπάρχον κλειδί",
    mydata_branch: "Υποκατάστημα (branch)",
    mydata_send: "Διαβίβαση στο myDATA",
    mydata_cancel: "Ακύρωση στο myDATA",
    mydata_classify: "Χαρακτηρισμός εξόδου",
    mydata_supplier_mark: "MARK παραστατικού προμηθευτή",
    mydata_category: "Κατηγορία εξόδου",
    cat_goods: "Αγορές εμπορευμάτων (κατ. 2.1)",
    cat_services: "Λήψη υπηρεσιών (κατ. 2.3)",
    cat_expenses: "Γενικά έξοδα (κατ. 2.4)",
    mydata_invoice_type: "Τύπος παραστατικού myDATA",
    type_1_1: "1.1 Τιμολόγιο Πώλησης",
    type_2_1: "2.1 Τιμολόγιο Παροχής Υπηρεσιών",
    type_11_1: "11.1 Απόδειξη Λιανικής Πώλησης",
    type_11_2: "11.2 Απόδειξη Παροχής Υπηρεσιών",
    md_status_none: "Μη διαβιβασμένο",
    md_status_sent: "Διαβιβάστηκε",
    md_status_mock: "Προσομοίωση",
    md_status_error: "Σφάλμα",
    md_status_cancelled: "Ακυρώθηκε",
    mark: "MARK",
    uid: "UID",
    mydata_sent_ok: "Διαβιβάστηκε επιτυχώς",
    mydata_error: "Σφάλμα διαβίβασης",
    mydata_cancelled_ok: "Ακυρώθηκε στο myDATA",
    mydata_classified_ok: "Ο χαρακτηρισμός διαβιβάστηκε",
    view_xml: "Προβολή XML",
    pending_sales: "Εκκρεμή τιμολόγια πωλήσεων",
    pending_purchases: "Αχαρακτήριστα τιμολόγια αγορών",
    send_all: "Διαβίβαση όλων",
    mydata_log: "Ιστορικό διαβιβάσεων",
    operation: "Ενέργεια",
    mydata_payroll: "Μισθοδοσία (17.1)",
    mydata_payroll_send: "Διαβίβαση μισθοδοσίας μήνα",
    mydata_payroll_hint: "Συγκεντρωτικό παραστατικό 17.1 με μικτές αποδοχές και εργοδοτικές εισφορές του μήνα.",
    sent: "Διαβιβασμένα",
    pending: "Εκκρεμή",
    errors: "Σφάλματα",
    classified: "Χαρακτηρισμένα",
    mock_banner: "Λειτουργία προσομοίωσης — δεν γίνεται πραγματική αποστολή στην ΑΑΔΕ. Ορίστε τα διαπιστευτήρια στις Ρυθμίσεις.",
    live_banner: "Ενεργή σύνδεση με ΑΑΔΕ",
    auth_fail_banner: "Η ΑΑΔΕ απορρίπτει τα στοιχεία σύνδεσης",
    auth_unknown_banner: "Η σύνδεση με την ΑΑΔΕ δεν έχει ελεγχθεί — πατήστε «Δοκιμή σύνδεσης» στις Ρυθμίσεις",
    last_check: "Τελευταίος έλεγχος",
    test_connection: "Δοκιμή σύνδεσης",
    testing_conn: "Έλεγχος…",
    conn_ok: "Η ΑΑΔΕ δέχτηκε τα στοιχεία σύνδεσης",
    conn_mock: "Λειτουργία δοκιμών (mock) — δεν γίνεται σύνδεση με την ΑΑΔΕ",
    save_before_test: "Αποθηκεύστε τις αλλαγές πριν τη δοκιμή σύνδεσης",
    err_company_afm_missing: "Συμπληρώστε έγκυρο Α.Φ.Μ. εταιρείας στις Ρυθμίσεις",
    err_counterpart_afm_missing: "Ο πελάτης δεν έχει έγκυρο Α.Φ.Μ.",
    err_document_not_issued: "Το παραστατικό πρέπει να είναι εκδοθέν ή εξοφλημένο",
    err_already_sent: "Έχει ήδη διαβιβαστεί",
    err_missing_credentials: "Λείπουν τα διαπιστευτήρια ΑΑΔΕ",
    err_mydata_forbidden: "Η ΑΑΔΕ απέρριψε τα διαπιστευτήρια myDATA (403). Ελέγξτε στις Ρυθμίσεις το Όνομα χρήστη (aade-user-id) και το Subscription Key, και ότι είναι κλειδιά παραγωγής (όχι δοκιμαστικού περιβάλλοντος).",
    err_invalid_mark: "Το MARK πρέπει να έχει 15 ψηφία",
    err_no_payslips: "Δεν υπάρχουν μισθοδοσίες για την περίοδο",
    err_not_sent: "Δεν έχει διαβιβαστεί",
    employer_contributions: "Εργοδοτικές εισφορές",
    sent_at: "Ημ/νία διαβίβασης",
    incoming_docs: "Εισερχόμενα παραστατικά προμηθευτών (myDATA)",
    incoming_hint: "Λήψη των παραστατικών που εξέδωσαν προμηθευτές προς την εταιρεία (RequestDocs). Αντιστοιχίζονται αυτόματα με τα τιμολόγια αγορών βάσει Α.Φ.Μ. και ποσού.",
    sync_incoming: "Λήψη από ΑΑΔΕ",
    inc_cancelled: "Ακυρωμένο",
    inc_cancelled_n: "ακυρωμένα",
    show_more: "Περισσότερα",
    incoming_search_ph: "Αναζήτηση προμηθευτή ή ΑΦΜ…",
    date_from: "Από",
    date_to: "Έως",
    clear_filters: "Καθαρισμός",
    incoming_synced: "νέα παραστατικά",
    incoming_matched: "αντιστοιχίστηκαν",
    md_status_new: "Νέο",
    md_status_linked: "Συνδέθηκε",
    md_status_classified: "Χαρακτηρίστηκε",
    create_document: "Δημιουργία τιμολογίου αγοράς",
    link_document: "Σύνδεση με τιμολόγιο",
    document_created: "Το τιμολόγιο αγοράς δημιουργήθηκε",
    linked_ok: "Η σύνδεση ολοκληρώθηκε",
    supplier_afm: "Α.Φ.Μ. εκδότη",
    linked_document: "Τιμολόγιο ERP",
    apd_title: "Αρχείο ΑΠΔ ΕΦΚΑ (CSL01)",
    apd_hint: "Δημιουργία αρχείου ΑΠΔ Κοινών Επιχειρήσεων για υποβολή στο e-ΕΦΚΑ από τις μισθοδοσίες της περιόδου.",
    apd_download: "Λήψη αρχείου ΑΠΔ",
    apd_warnings: "Ελλείψεις στοιχείων",
    warn_company_ame: "Λείπει το Α.Μ.Ε. εργοδότη (Ρυθμίσεις)",
    warn_company_kad: "Λείπει ο Κ.Α.Δ. (Ρυθμίσεις)",
    warn_company_afm: "Λείπει έγκυρο Α.Φ.Μ. εταιρείας",
    warn_employee: "Εργαζόμενος",
    insurance_days: "Ημέρες ασφάλισης",
    father_name: "Όνομα πατρός",
    mother_name: "Όνομα μητρός",
    specialty_code: "Κωδ. ειδικότητας (ΑΠΔ)",
    coverage_code: "Κωδ. πακέτου κάλυψης (ΑΠΔ)",
    ame: "Α.Μ.Ε. (ΕΦΚΑ)",
    kad: "Κ.Α.Δ.",
    postal_code: "Τ.Κ.",
    err_already_linked: "Έχει ήδη συνδεθεί με τιμολόγιο",
    all_statuses_inc: "Όλα",
    nav_ledger: "Λογιστική",
    trial_balance: "Ισοζύγιο",
    general_ledger: "Καθολικό",
    chart_of_accounts: "Λογιστικό Σχέδιο",
    journal: "Ημερολόγιο Άρθρων",
    account: "Λογαριασμός",
    account_code: "Κωδικός",
    account_name: "Ονομασία",
    account_type: "Είδος",
    acc_asset: "Ενεργητικό",
    acc_liability: "Υποχρεώσεις",
    acc_equity: "Καθαρή θέση",
    acc_income: "Έσοδα",
    acc_expense: "Έξοδα",
    opening: "Από μεταφορά",
    debit: "Χρέωση",
    credit: "Πίστωση",
    closing: "Υπόλοιπο",
    closing_debit: "Χρεωστικό υπόλοιπο",
    closing_credit: "Πιστωτικό υπόλοιπο",
    select_account: "Επιλέξτε λογαριασμό",
    new_account: "Νέος λογαριασμός",
    edit_account: "Επεξεργασία λογαριασμού",
    account_saved: "Ο λογαριασμός αποθηκεύτηκε",
    account_deleted: "Ο λογαριασμός διαγράφηκε",
    confirm_delete_account: "Ο λογαριασμός θα διαγραφεί. Συνέχεια;",
    err_code_exists: "Ο κωδικός υπάρχει ήδη",
    err_system_account: "Λογαριασμός συστήματος — δεν διαγράφεται",
    err_account_has_entries: "Ο λογαριασμός έχει κινήσεις",
    err_unbalanced: "Το άρθρο δεν ισοσκελίζει (Χρέωση ≠ Πίστωση)",
    err_min_two_lines: "Απαιτούνται τουλάχιστον δύο γραμμές",
    new_entry: "Νέο χειρόγραφο άρθρο",
    entry_saved: "Το άρθρο καταχωρήθηκε",
    entry_deleted: "Το άρθρο διαγράφηκε",
    confirm_delete_entry: "Το άρθρο θα διαγραφεί. Συνέχεια;",
    source: "Προέλευση",
    src_document: "Παραστατικό",
    src_payment: "Πληρωμή",
    src_settlement: "Εξόφληση",
    src_payslip: "Μισθοδοσία",
    src_payslip_payment: "Πληρωμή μισθοδοσίας",
    src_manual: "Χειρόγραφο",
    all_sources: "Όλες οι προελεύσεις",
    only_leaf: "Μόνο αναλυτικοί",
    ledger_hint: "Οι εγγραφές δημιουργούνται αυτόματα από τιμολόγια, αγορές, πληρωμές και μισθοδοσίες (Ε.Λ.Π.). Χειρόγραφα άρθρα προστίθενται από το Ημερολόγιο.",
    system_acc: "Συστήματος",
    export_csv: "Εξαγωγή CSV",
    export_excel: "Εξαγωγή Excel (λογιστής)",
    aade_lookup: "Άντληση από ΑΑΔΕ",
    aade_lookup_ok: "Τα στοιχεία αντλήθηκαν από το Μητρώο ΑΑΔΕ",
    aade_lookup_mock: "Προσομοίωση — δοκιμαστικά στοιχεία (ορίστε κωδικούς στις Ρυθμίσεις)",
    aade_registry_title: "Μητρώο ΑΑΔΕ — Αναζήτηση Βασικών Στοιχείων",
    aade_registry_hint: "Ειδικοί κωδικοί web service (όχι TAXISnet) από myAADE → Διαχείριση Ειδικών Κωδικών. Αποθηκεύονται μόνο στον server.",
    aade_username: "Όνομα χρήστη (ειδικοί κωδικοί)",
    aade_password: "Κωδικός (ειδικοί κωδικοί)",
    aade_called_by: "Α.Φ.Μ. καλούντος (προαιρετικό)",
    mode_live: "Πραγματική σύνδεση",
    err_afm_invalid: "Το Α.Φ.Μ. πρέπει να έχει 9 ψηφία",
    err_afm_not_found: "Δεν βρέθηκε Α.Φ.Μ. στο Μητρώο",
    err_registry_bad_credentials: "Η ΑΑΔΕ απέρριψε τα διαπιστευτήρια: μη έγκυρος συνδυασμός χρήστη/κωδικού. Χρειάζονται οι Ειδικοί Κωδικοί web service (myAADE → Μητρώο & Επικοινωνία → Διαχείριση Ειδικών Κωδικών), όχι οι κωδικοί TaxisNet.",
    activity_field: "Δραστηριότητα",
    legal_form: "Νομική μορφή",
    inactive_afm: "ΑΝΕΝΕΡΓΟ Α.Φ.Μ.",
  },
  en: {
    app_title: "Ergo",
    app_subtitle: "Trade · Services · Manufacturing",
    nav_dashboard: "Dashboard",
    nav_documents: "Documents",
    nav_contacts: "Customers & Suppliers",
    nav_settings: "Company Settings",
    nav_users: "Users",
    nav_brand: "Logo",
    brand_hint: "Choose the logo look. Each variant is shown on light, dark backgrounds and at small sizes. The choice applies instantly to the sidebar and login page.",
    brand_active: "Active",
    brand_pick: "Select",
    brand_saved: "Logo updated",
    nav_sales: "Sales",
    nav_purchases: "Purchases – Expenses",
    account_suggested: "Suggested account from the last transaction:",
    history: "Activity history",
    created_by: "Created by",
    updated_by: "Last change",
    no_history: "No recorded history",
    hist_created: "Created",
    hist_updated: "Edited",
    hist_status: "Status change",
    login_hero: "Your business accounting, in one system.",
    login_hero_sub: "Documents, contacts, payroll, myDATA and General Ledger — with per-user access control.",
    login_title: "Sign in",
    login_sub: "Enter your account credentials",
    login_button: "Sign in",
    username: "Username",
    password: "Password",
    logout: "Sign out",
    you: "you",
    full_name: "Full name",
    role: "Role",
    role_superadmin: "Super admin",
    role_admin: "Administrator",
    role_user: "User",
    modules: "Access",
    modules_access: "Tabs the user can see",
    admin_all_modules: "Administrators have access to all tabs and user management.",
    active: "Active",
    inactive: "Inactive",
    created: "Created",
    new_user: "New user",
    edit_user: "Edit user",
    users_hint: "Create users and choose which tabs each one sees. Only the Super admin can delete users.",
    user_saved: "User saved",
    user_deleted: "User deleted",
    confirm_delete_user: "The user will be permanently deleted. Continue?",
    new_password_optional: "New password (optional)",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password (min 6 chars)",
    password_changed: "Password changed",
    err_invalid_credentials: "Wrong username or password",
    err_too_many_attempts: "Too many failed attempts — try again in 15 minutes",
    err_user_inactive: "Account is inactive",
    err_not_authenticated: "Sign in required",
    err_token_expired: "Session expired — sign in again",
    err_forbidden: "You don't have access",
    err_username_exists: "Username already exists",
    err_invalid_user_data: "Username ≥3 and password ≥6 characters",
    err_password_too_short: "Password must be at least 6 characters",
    err_wrong_password: "Wrong current password",
    err_cannot_delete_superadmin: "Super admin cannot be deleted",
    err_cannot_edit_superadmin: "You cannot edit the Super admin",
    err_only_superadmin_deletes: "Only the Super admin can delete users",
    err_cannot_delete_self: "You cannot delete yourself",
    err_cannot_deactivate_self: "You cannot deactivate yourself",
    kpi_total_revenue: "Collected Revenue",
    kpi_unpaid_invoices: "Unpaid Invoices",
    kpi_active_contacts: "Active Contacts",
    kpi_documents: "Documents",
    kpi_overdue: "overdue",
    kpi_customers: "Customers",
    kpi_suppliers: "Suppliers",
    kpi_purchases: "Purchases",
    chart_title: "Sales & Purchases (6 months)",
    chart_sales: "Sales",
    chart_purchases: "Purchases",
    recent_docs: "Recent Documents",
    vat_summary: "VAT Summary",
    vat_out: "Output VAT",
    vat_in: "Input VAT",
    vat_due: "VAT payable",
    view_all: "View all",
    doc_invoice: "Sales Invoice",
    doc_service_invoice: "Services Invoice",
    doc_retail_receipt: "Retail Receipt",
    doc_purchase: "Purchase Invoice",
    doc_purchase_service: "Services Invoice (Purchase)",
    doc_expense: "Retail Receipt (Expense)",
    group_all: "All",
    group_sales: "Sales",
    group_purchases: "Purchases – Expenses",
    group_total: "Selection total",
    new_sale: "New Sale",
    new_purchase: "New Purchase / Expense",
    search_account: "Search account (code or name)…",
    no_results: "No results",
    account_required_hint: "Expense documents require a 3rd-level expense account on every line before issuing.",
    account_required_hint_sales: "Sales documents require a 3rd-level income account (group 7) on every line before issuing.",
    err_account_required: "Select an expense account on every line before issuing",
    err_unknown_account: "Unknown chart-of-accounts code",
    status_draft: "Draft",
    status_issued: "Issued",
    status_paid: "Paid",
    status_cancelled: "Cancelled",
    status_overdue: "Overdue",
    new_document: "New Document",
    edit_document: "Edit Document",
    new_contact: "New Contact",
    edit_contact: "Edit Contact",
    name: "Company / Name",
    type: "Type",
    customer: "Customer",
    supplier: "Supplier",
    both: "Customer & Supplier",
    vat_id: "VAT No. (AFM)",
    tax_office: "Tax Office (DOY)",
    address: "Address",
    city: "City",
    phone: "Phone",
    email: "Email",
    payment_terms: "Payment terms (days)",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    search: "Search...",
    all_types: "All types",
    all_statuses: "All statuses",
    no_results: "No results found",
    confirm_delete_title: "Confirm deletion",
    confirm_delete_contact: "The contact will be permanently deleted. Continue?",
    confirm_delete_doc: "The document will be permanently deleted. Continue?",
    contact_saved: "Contact saved",
    contact_deleted: "Contact deleted",
    contact_has_docs: "Contact has documents and cannot be deleted",
    doc_saved: "Document saved",
    doc_deleted: "Document deleted",
    status_updated: "Status updated",
    settings_saved: "Settings saved",
    error: "Something went wrong",
    number: "Number",
    date: "Date",
    issue_date: "Issue Date",
    due_date: "Due Date",
    payment_method: "Payment Method",
    pay_bank: "Bank transfer",
    pay_cash: "Cash",
    pay_card: "Card",
    pay_credit: "On credit",
    contact: "Contact",
    select_contact: "Select contact",
    status: "Status",
    total: "Total",
    line_items: "Line Items",
    description: "Description",
    quantity: "Qty",
    unit_price: "Unit Price",
    vat_rate: "VAT %",
    vat_deductible: "VAT deductible",
    vat_deductible_hint: "Untick “VAT deductible” for expenses with non-deductible VAT (e.g. hospitality, passenger cars, car fuel). The VAT is then charged to the expense account instead of 54.00.",
    non_deductible_short: "non-ded.",
    supplier_number: "Supplier document no.",
    supplier_number_ph: "e.g. INV A-1234",
    err_supplier_number_exists: "A document from this supplier with the same number already exists",
    line_total: "Amount",
    add_line: "Add line",
    subtotal: "Subtotal",
    vat_amount: "VAT",
    total_amount: "Grand Total",
    print_pdf: "Print / PDF",
    back: "Back",
    change_status: "Change status",
    mark_issued: "Issue",
    mark_paid: "Mark paid",
    mark_cancelled: "Cancel",
    issuer: "Issuer",
    recipient: "Recipient",
    signature: "Signature & Stamp",
    company_settings: "Company Details",
    company_settings_hint: "Shown on printed documents.",
    company_name: "Company Name",
    activity: "Business Activity",
    iban: "IBAN",
    required: "Required field",
    afm_invalid: "VAT number must be 9 digits",
    items_required: "Add at least one line with a description",
    documents_of: "Contact documents",
    theme: "Theme",
    welcome: "Welcome",
    dashboard_hint: "A snapshot of your business today.",
    dashboard_greeting: "Financial overview",
    types: "Types",
    nav_payroll: "Payroll",
    payments: "Receipts & Payments",
    add_payment: "Record payment",
    amount: "Amount",
    reference: "Receipt / payment reference",
    paid_amount: "Paid",
    balance: "Balance",
    payment_saved: "Payment recorded",
    payment_deleted: "Payment deleted",
    amount_exceeds: "Amount exceeds balance",
    confirm_delete_payment: "The payment will be permanently deleted. Continue?",
    no_payments: "No payments yet",
    pay_full: "Full balance",
    contact_card: "Contact Card",
    receivable: "Receivables (sales)",
    payable: "Payables (purchases)",
    invoiced: "Invoiced",
    collected: "Collected",
    paid_out: "Paid out",
    open_balance: "Open balance",
    overdue_balance: "Overdue",
    transactions: "Transaction history",
    payments_history: "Payment history",
    employees: "Employees",
    payslips: "Payslips",
    new_employee: "New Employee",
    edit_employee: "Edit Employee",
    employee: "Employee",
    first_name: "First name",
    last_name: "Last name",
    amka: "AMKA (SSN)",
    ama: "EFKA Reg. No.",
    position: "Position",
    hire_date: "Hire date",
    birth_date: "Birth date",
    children: "Children",
    employment_type: "Employment",
    full_time: "Full-time",
    part_time: "Part-time",
    weekly_hours: "Hours / week",
    gross_salary: "Gross monthly salary",
    hourly_rate: "Hourly rate",
    active: "Active",
    inactive: "Inactive",
    employee_saved: "Employee saved",
    employee_deleted: "Employee deleted",
    employee_has_payslips: "Employee has payslips and cannot be deleted",
    confirm_delete_employee: "The employee will be permanently deleted. Continue?",
    kind: "Kind",
    kind_salary: "Monthly salary",
    kind_christmas: "Christmas bonus",
    kind_easter: "Easter bonus",
    kind_leave: "Leave allowance",
    period: "Period",
    year: "Year",
    month: "Month",
    run_payroll: "Run payroll",
    run_payroll_hint: "Creates payslips for all active employees for the period.",
    payslips_created: "payslips created",
    payslips_skipped: "already existed",
    gross: "Gross",
    efka_employee: "Employee contributions (EFKA)",
    efka_employer: "Employer contributions (EFKA)",
    taxable: "Taxable",
    fmy: "Income tax withheld",
    net: "Net pay",
    employer_cost: "Employer cost",
    payslip: "Payslip",
    payslip_deleted: "Payslip deleted",
    confirm_delete_payslip: "The payslip will be permanently deleted. Continue?",
    payroll_settings: "Contribution rates",
    rate_employee: "Employee %",
    rate_employer: "Employer %",
    days_basis: "Basis days",
    kpi_payroll: "Monthly payroll",
    total_net: "Total net",
    total_cost: "Total cost",
    tax_note: "Based on the 2026 tax scale (Law 5246/2025), 14 salaries/year, tax credit by children. Bonuses increased by 4.166%.",
    all_kinds: "All kinds",
    payroll_paid_on: "Paid on",
    afm_short: "VAT",
    absences: "Leave & Absences",
    new_absence: "New entry",
    edit_absence: "Edit entry",
    abs_annual_leave: "Annual leave",
    abs_sick: "Sick leave",
    abs_unpaid: "Unpaid leave",
    abs_overwork: "Overwork (+20%)",
    abs_overtime: "Overtime (+40%)",
    start_date: "From",
    end_date: "To",
    hours: "Hours",
    days: "Days",
    absence_saved: "Entry saved",
    absence_deleted: "Entry deleted",
    confirm_delete_absence: "The entry will be permanently deleted. Continue?",
    leave_balance: "Leave balances for the year",
    entitlement: "Entitlement",
    used: "Used",
    remaining: "Remaining",
    sick_days: "Sick days",
    unpaid_days: "Unpaid days",
    overtime_hours: "Overtime hrs",
    base_gross: "Base salary",
    overtime_pay: "Overwork / overtime pay",
    sick_deduction: "Sick leave deduction",
    unpaid_deduction: "Unpaid leave deduction",
    adjustments: "Additions / Deductions",
    recalculate: "Recalculate",
    recalculated: "Payslip recalculated",
    all_employees: "All employees",
    select_employee: "Select employee",
    sick_rule: "Sick: first days / year",
    sick_first_pct: "Deduction first days %",
    sick_after_pct: "Deduction following days %",
    absence_note: "Absences of the month are applied automatically to the monthly payslip. Sick leave: first 3 days/year deducted 50%, following days 100% (EFKA subsidy). Hourly rate = salary × 6 / (25 × weekly hours).",
    no_working_days: "The range contains no working days",
    all_year: "Whole year",
    nav_mydata: "myDATA (AADE)",
    mydata_title: "AADE myDATA Integration",
    mydata_settings_hint: "Credentials are issued via myAADE → myDATA REST API registration. Stored server-side only.",
    mydata_mode: "Environment",
    mode_mock: "Simulation (MOCK)",
    mode_dev: "AADE Test",
    mode_production: "AADE Production",
    mydata_user_id: "aade-user-id",
    mydata_key: "Ocp-Apim-Subscription-Key",
    mydata_key_hint: "Leave blank to keep the existing key",
    mydata_branch: "Branch",
    mydata_send: "Submit to myDATA",
    mydata_cancel: "Cancel in myDATA",
    mydata_classify: "Classify expense",
    mydata_supplier_mark: "Supplier invoice MARK",
    mydata_category: "Expense category",
    cat_goods: "Purchases of goods (cat. 2.1)",
    cat_services: "Services received (cat. 2.3)",
    cat_expenses: "General expenses (cat. 2.4)",
    mydata_invoice_type: "myDATA invoice type",
    type_1_1: "1.1 Sales Invoice",
    type_2_1: "2.1 Services Invoice",
    type_11_1: "11.1 Retail Sales Receipt",
    type_11_2: "11.2 Retail Services Receipt",
    md_status_none: "Not submitted",
    md_status_sent: "Submitted",
    md_status_mock: "Simulated",
    md_status_error: "Error",
    md_status_cancelled: "Cancelled",
    mark: "MARK",
    uid: "UID",
    mydata_sent_ok: "Submitted successfully",
    mydata_error: "Submission error",
    mydata_cancelled_ok: "Cancelled in myDATA",
    mydata_classified_ok: "Classification submitted",
    view_xml: "View XML",
    pending_sales: "Pending sales invoices",
    pending_purchases: "Unclassified purchase invoices",
    send_all: "Submit all",
    mydata_log: "Submission history",
    operation: "Operation",
    mydata_payroll: "Payroll (17.1)",
    mydata_payroll_send: "Submit monthly payroll",
    mydata_payroll_hint: "Aggregate 17.1 document with gross pay and employer contributions of the month.",
    sent: "Submitted",
    pending: "Pending",
    errors: "Errors",
    classified: "Classified",
    mock_banner: "Simulation mode — nothing is actually sent to AADE. Set credentials in Settings.",
    live_banner: "Live connection to AADE",
    auth_fail_banner: "AADE rejects the connection credentials",
    auth_unknown_banner: "AADE connection not verified yet — press “Test connection” in Settings",
    last_check: "Last check",
    test_connection: "Test connection",
    testing_conn: "Checking…",
    conn_ok: "AADE accepted the credentials",
    conn_mock: "Mock mode — no connection to AADE",
    save_before_test: "Save your changes before testing the connection",
    err_company_afm_missing: "Set a valid company VAT number in Settings",
    err_counterpart_afm_missing: "Customer has no valid VAT number",
    err_document_not_issued: "Document must be issued or paid",
    err_already_sent: "Already submitted",
    err_missing_credentials: "AADE credentials are missing",
    err_mydata_forbidden: "AADE rejected the myDATA credentials (403). Check the user id and Subscription Key in Settings and that they are production (not dev) keys.",
    err_invalid_mark: "MARK must be 15 digits",
    err_no_payslips: "No payslips for this period",
    err_not_sent: "Not submitted",
    employer_contributions: "Employer contributions",
    sent_at: "Submitted at",
    incoming_docs: "Incoming supplier documents (myDATA)",
    incoming_hint: "Fetch documents issued by suppliers to the company (RequestDocs). Auto-matched to purchase invoices by VAT number and amount.",
    sync_incoming: "Fetch from AADE",
    inc_cancelled: "Cancelled",
    inc_cancelled_n: "cancelled",
    show_more: "Show more",
    incoming_search_ph: "Search supplier or VAT no…",
    date_from: "From",
    date_to: "To",
    clear_filters: "Clear",
    incoming_synced: "new documents",
    incoming_matched: "matched",
    md_status_new: "New",
    md_status_linked: "Linked",
    md_status_classified: "Classified",
    create_document: "Create purchase invoice",
    link_document: "Link to invoice",
    document_created: "Purchase invoice created",
    linked_ok: "Linked successfully",
    supplier_afm: "Issuer VAT No.",
    linked_document: "ERP invoice",
    apd_title: "EFKA APD file (CSL01)",
    apd_hint: "Generate the APD (Analytical Periodic Declaration) file for e-EFKA submission from the period's payslips.",
    apd_download: "Download APD file",
    apd_warnings: "Missing data",
    warn_company_ame: "Employer EFKA registration number (AME) missing (Settings)",
    warn_company_kad: "Activity code (KAD) missing (Settings)",
    warn_company_afm: "Valid company VAT number missing",
    warn_employee: "Employee",
    insurance_days: "Insurance days",
    father_name: "Father's name",
    mother_name: "Mother's name",
    specialty_code: "Specialty code (APD)",
    coverage_code: "Coverage package code (APD)",
    ame: "Employer EFKA No. (AME)",
    kad: "Activity code (KAD)",
    postal_code: "Postal code",
    err_already_linked: "Already linked to an invoice",
    all_statuses_inc: "All",
    nav_ledger: "Accounting",
    trial_balance: "Trial Balance",
    general_ledger: "General Ledger",
    chart_of_accounts: "Chart of Accounts",
    journal: "Journal",
    account: "Account",
    account_code: "Code",
    account_name: "Name",
    account_type: "Type",
    acc_asset: "Asset",
    acc_liability: "Liability",
    acc_equity: "Equity",
    acc_income: "Income",
    acc_expense: "Expense",
    opening: "Opening",
    debit: "Debit",
    credit: "Credit",
    closing: "Balance",
    closing_debit: "Debit balance",
    closing_credit: "Credit balance",
    select_account: "Select account",
    new_account: "New account",
    edit_account: "Edit account",
    account_saved: "Account saved",
    account_deleted: "Account deleted",
    confirm_delete_account: "The account will be deleted. Continue?",
    err_code_exists: "Code already exists",
    err_system_account: "System account — cannot be deleted",
    err_account_has_entries: "Account has entries",
    err_unbalanced: "Entry is not balanced (Debit ≠ Credit)",
    err_min_two_lines: "At least two lines required",
    new_entry: "New manual entry",
    entry_saved: "Entry posted",
    entry_deleted: "Entry deleted",
    confirm_delete_entry: "The entry will be deleted. Continue?",
    source: "Source",
    src_document: "Document",
    src_payment: "Payment",
    src_settlement: "Settlement",
    src_payslip: "Payroll",
    src_payslip_payment: "Payroll payment",
    src_manual: "Manual",
    all_sources: "All sources",
    only_leaf: "Leaf accounts only",
    ledger_hint: "Entries are generated automatically from invoices, purchases, payments and payroll (Greek GAAP). Manual entries are added from the Journal.",
    system_acc: "System",
    export_csv: "Export CSV",
    export_excel: "Export Excel (accountant)",
    aade_lookup: "Fetch from AADE",
    aade_lookup_ok: "Details fetched from the AADE registry",
    aade_lookup_mock: "Simulation — demo data (set credentials in Settings)",
    aade_registry_title: "AADE Registry — Business Details Lookup",
    aade_registry_hint: "Special web-service credentials (not TAXISnet) from myAADE → Special Credentials Management. Stored server-side only.",
    aade_username: "Username (special credentials)",
    aade_password: "Password (special credentials)",
    aade_called_by: "Caller VAT No. (optional)",
    mode_live: "Live connection",
    err_afm_invalid: "VAT number must be 9 digits",
    err_afm_not_found: "VAT number not found in registry",
    err_registry_bad_credentials: "AADE rejected the credentials: invalid username/password. Use the special web-service codes (myAADE → Registry & Communication → Special Codes management), not TaxisNet codes.",
    activity_field: "Business activity",
    legal_form: "Legal form",
    inactive_afm: "INACTIVE VAT No.",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "el");
  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "el" ? "en" : "el";
      localStorage.setItem("lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
  return <LanguageContext.Provider value={{ lang, toggle, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);

export const fmtMoney = (v) =>
  new Intl.NumberFormat("el-GR", { style: "currency", currency: "EUR" }).format(v || 0);

const pad = (n) => String(n).padStart(2, "0");

export const fmtDate = (iso) => {
  if (!iso) return "—";
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;
  const d = new Date(iso);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${fmtDate(iso)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
